
(function () {
    'use strict';

    angular.module('tikonApp')
        .controller('EducationMovieController', EducationMovieController);

    EducationMovieController.$inject = ['$uibModalInstance', 'link', '$sce'];

    function EducationMovieController($uibModalInstance, link, $sce) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.link = $sce.trustAsHtml(link)

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
